module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/Police Verification/police-verification-grid/police-verification-grid.component.css
// module id = ./src/app/hrms/serviceregister/Police Verification/police-verification-grid/police-verification-grid.component.css
// module chunks = main